import { render, staticRenderFns } from "./NotaExame.vue?vue&type=template&id=1a89a2ce&"
import script from "./NotaExame.vue?vue&type=script&lang=js&"
export * from "./NotaExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports